import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 20.9l4.95-4.95a7 7 0 10-9.9 0L12 20.9zm0 2.83l-6.36-6.37a9 9 0 1112.72 0L12 23.73z"/>
    <path fill="#34CEFF" fillRule="evenodd" d="M12 15a4 4 0 110-8 4 4 0 010 8zm1.41-2.59A2 2 0 1110.6 9.6a2 2 0 012.82 2.82z" clipRule="evenodd"/>
  </SvgIcon>
);